import { render, staticRenderFns } from "./common-table-label.vue?vue&type=template&id=40d53fa2&scoped=true"
import script from "./common-table-label.vue?vue&type=script&lang=js"
export * from "./common-table-label.vue?vue&type=script&lang=js"
import style0 from "./common-table-label.vue?vue&type=style&index=0&id=40d53fa2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d53fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d53fa2')) {
      api.createRecord('40d53fa2', component.options)
    } else {
      api.reload('40d53fa2', component.options)
    }
    module.hot.accept("./common-table-label.vue?vue&type=template&id=40d53fa2&scoped=true", function () {
      api.rerender('40d53fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common-table-label/common-table-label.vue"
export default component.exports